(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["river-labs-specifications-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('river-specs')) {
    customElements.define(
      'river-specs',
      class RiverSpecs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[data-specs-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-specs-panel]'));

          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.selectTab(index));
            tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
          });
        }

        selectTab(index, moveFocus = false) {
          this.tabs.forEach((tab, tabIndex) => {
            const isActive = tabIndex === index;
            tab.setAttribute('aria-selected', String(isActive));
            tab.tabIndex = isActive ? 0 : -1;
            this.panels[tabIndex].hidden = !isActive;
          });

          if (moveFocus) this.tabs[index].focus();
        }

        handleKeydown(event, index) {
          let nextIndex;

          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;

          if (nextIndex === undefined) return;
          event.preventDefault();
          this.selectTab(nextIndex, true);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
